import { render, staticRenderFns } from "./CollectorsCmp.vue?vue&type=template&id=6ce50e71&scoped=true"
import script from "./CollectorsCmp.vue?vue&type=script&lang=js"
export * from "./CollectorsCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce50e71",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce50e71')) {
      api.createRecord('6ce50e71', component.options)
    } else {
      api.reload('6ce50e71', component.options)
    }
    module.hot.accept("./CollectorsCmp.vue?vue&type=template&id=6ce50e71&scoped=true", function () {
      api.rerender('6ce50e71', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/cmp/Query/CollectorsCmp.vue"
export default component.exports